/**
 * @generated SignedSource<<4ae52768b16076b8d0cde983c3af9c2c>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ArchivedPageBannerV2ArchivedPageBannerContainerQuery$variables = {
  contentId?: string | null | undefined;
};
export type ArchivedPageBannerV2ArchivedPageBannerContainerQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly status: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ArchivedPageBannerV2ArchivedPageBannerContainerQuery = {
  response: ArchivedPageBannerV2ArchivedPageBannerContainerQuery$data;
  variables: ArchivedPageBannerV2ArchivedPageBannerContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "archived",
          "current"
        ]
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
    "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
    "metadata": {},
    "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
    "operationKind": "query",
    "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
  }
};
})();

(node as any).hash = "c639141edd782146ad296893dc79f146";

export default node;
